import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { CatalogoItemResponse } from "../../../shared/response/proyectos/CatalogoItemResponse";
import { CatalogoItemPayload } from "../../../shared/services/api/payload/proyectos/CatalogoItemPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { CatalogoService, toCatalogoItemResponse } from "./CatalogoService";

/** Crea o edita cualquier campo de un ítem del catálogo maestro; el resultado reemplaza la fila de su cultivo. */
export class CatalogoItemSaveService extends ServiceSaveBase<CatalogoItemResponse, CatalogoItemPayload> {
  protected readonly cache = CatalogoService.instance;

  /** gRPC-Web (`GuardarCatalogoItem`): tipo (CAPEX/OPEX) y sección se derivan de la fase en el servidor. */
  protected async sendSave(p: CatalogoItemPayload): Promise<CatalogoItemResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).guardarCatalogoItem({
      id: p.id ?? undefined,
      cultivoId: p.cultivoId,
      faseId: p.faseId,
      sub: p.sub,
      nombre: p.nombre,
      categoria: p.categoria,
      unidad: p.unidad,
      cantUnidad: p.cantUnidad,
      cantidadPorHa: p.cantidadPorHa,
      tipoP: p.tipoP,
      precioReferencial: p.precioReferencial !== null ? BigInt(Math.round(p.precioReferencial)) : undefined,
      freq: p.freq,
      freqUnidad: p.freqUnidad ?? undefined,
      incl: p.incl,
      nitro: p.nitro,
    }));
    return toCatalogoItemResponse(r);
  }
}
